// Triggers a browser download for a generated PDF blob.

export function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  // Revoke after the browser has had a chance to start the download; revoking
  // synchronously can cancel the download in some browsers.
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}

/** Sanitizes a string into a safe filename fragment. */
export function toFilenameSlug(value: string): string {
  return (
    value
      .trim()
      .replace(/[^a-zA-Z0-9-_]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '') || 'report'
  );
}
